import { CompatibleUnitCodeQuery, ConvertUnitCodeQuery } from '@treetop/shared/model';

export interface UnitQuery {
  code: string;
}

export function convertParamsToConvertUnitQuery(value: number, fromCode: string, toCode: string, molarMass?: number): ConvertUnitCodeQuery {
  fromCode = convertUnitToEncodedQueryAttributes(fromCode);
  toCode = convertUnitToEncodedQueryAttributes(toCode);

  return {
    value,
    fromCode,
    toCode,
    molarMass: molarMass ? molarMass : null,
  };
}

export function convertParamsToCompatibleUnitQuery(unitCode: string, isMolarMassAvailable: boolean): CompatibleUnitCodeQuery {
  const code = convertUnitToEncodedQueryAttributes(unitCode);

  return { code, isMolarMassAvailable };
}

export function convertUnitToEncodedQueryAttributes(unitCode: string): string {
  return encodeURIComponent(unitCode);
}
